import { useMemo } from 'react';

import { getFilmOtt } from '../utils/get-film-ott';

import { useReadFilmPlayerBaseInfo } from './use-read-film-player-base-info';

export function useFilmOtt(contentId: string) {
    const filmOrVideo = useReadFilmPlayerBaseInfo(contentId);

    return useMemo(() => (filmOrVideo ? getFilmOtt(filmOrVideo) : undefined), [filmOrVideo]);
}
